import React from 'react'
import { Alert } from 'react-bootstrap'

const SuccessMessage = ({ message }) => {
  return message && <Alert variant='success'>{message}</Alert>
}

export default SuccessMessage
